import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { putUpdateUser } from "../../features/action/fetchAuth";
import { renderImage } from "../../util/main";

export const UpdateUser = ({ item, setUpdateUsers }) => {
  const dispatch = useDispatch();
  const [rool, setRool] = useState(item.rool || "");
  const [fullname, setFullname] = useState(item.fullname || "");
  const [email, setEmail] = useState(item.email || "");
  const [password, setPassword] = useState("");

  const handleSave = (e) => {
    e.stopPropagation();
    dispatch(putUpdateUser(item, rool, fullname, email, password));
    setUpdateUsers(false);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setUpdateUsers(false);
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-sm rounded-2xl shadow-2xl overflow-hidden flex flex-col transform transition-all h-[80vh] overflow-y-auto">
        {/* Header Section */}
        <div className="relative bg-gradient-to-r from-blue-50 to-indigo-50 p-6 flex flex-col items-center border-b border-gray-100 shrink-0">
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 p-1 bg-white/50 hover:bg-white rounded-full text-gray-400 hover:text-gray-600 transition-all shadow-sm"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <div className="w-24 h-24 rounded-full overflow-hidden mb-3 shadow-lg ring-4 ring-white bg-white flex items-center justify-center">
            {renderImage(item.fullname)}
          </div>

          <h2 className="text-xl font-bold text-gray-800 tracking-tight">
            {item.username}
          </h2>
          <p className="text-sm text-gray-500 font-medium">{email}</p>
        </div>

        {/* Form Section */}
        <div className="p-6 space-y-4 overflow-y-auto">
          <div className="space-y-3">
            {/* Full Name */}
            <div>
              <label className="text-xs font-semibold text-gray-500 ml-1 mb-1 block">
                Full Name
              </label>
              <input
                value={fullname}
                autoComplete="off"
                onChange={(e) => setFullname(e.target.value)}
                placeholder={"Full Name"}
                className="w-full h-[44px] px-4 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-sm"
              />
            </div>

            {/* Email */}
            <div>
              <label className="text-xs font-semibold text-gray-500 ml-1 mb-1 block">
                Email
              </label>
              <input
                value={email}
                autoComplete="off"
                onChange={(e) => setEmail(e.target.value)}
                placeholder={"Email"}
                type="email"
                className="w-full h-[44px] px-4 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-sm"
              />
            </div>

            {/* <div>
              <label className="text-xs font-semibold text-gray-500 ml-1 mb-1 block">
                Login
              </label>
              <input
                placeholder="Login"
                className="w-full h-[44px] px-4 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-sm"
                // onChange={(e) => setSidePrint(e.target.value)}
                // value={sidePrint}
              />
            </div> */}

            <div>
              <label className="text-xs font-semibold text-gray-500 ml-1 mb-1 block">
                Password
              </label>
              <input
                type="password"
                autoComplete="new-password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-[44px] px-4 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-sm"
              />
            </div>

            <div>
              <label className="text-xs font-semibold text-gray-500 ml-1 mb-1 block">
                Role
              </label>
              <div className="relative">
                <select
                  name="Rool"
                  value={rool}
                  onChange={(e) => setRool(e.target.value)}
                  className="w-full h-[44px] px-4 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-sm appearance-none cursor-pointer text-gray-700"
                >
                  <option value="">Choose a Role</option>
                  <option value="admin">Admin</option>
                  <option value="designer">Designer</option>
                  <option value="director">Director</option>
                  <option value="manager">Manager</option>
                  <option value="sewing">Sewing</option>
                  <option value="keeper">Keeper</option>
                  <option value="guest">Guest</option>
                </select>
                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <button
            onClick={handleSave}
            className="w-full mt-2 h-[44px] bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl shadow-lg shadow-blue-500/30 transition-all active:scale-[0.98] flex items-center justify-center gap-2"
          >
            <span>Save Changes</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
